import {
    Badge,
    Button,
    Icon,
    Link,
    TextField,
    Tooltip,
    Modal,
    Popover,
    ActionList,
    Pagination,
    Text,
    BlockStack,
    InlineStack,
    Card,
    Box,
    Divider,
    InlineGrid,
    Bleed,
    Thumbnail
} from '@shopify/polaris';
import { ExternalMinor, SearchMinor } from '@shopify/polaris-icons';
import { Table } from 'antd';
import React, { useCallback, useState, useEffect, ReactElement, useContext } from 'react';
import { DI, DIProps } from '../../../../Core';
import debounce from 'lodash/debounce';
import Noimage from '../../../../../public/files/noImage.png';
import { DeletingSkeleton } from '../skeleton/LinkingSkeleton';
import { useTranslation } from "react-i18next";
import { ProductLinkingContext } from './utils/context/context';
import AmazonBtnIcon from "../../../../Asests/Images/amazon_icon.png";
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { isAdminLoggedIn } from '../../Panel/index';
import { ViewMoreInfo } from './utils/utils';
import { LazyThumbnail } from '../../Editproduct/components/Image/Image';
import { modifyImageUrl } from '../../Listing Grid/Utilities/Helper';


interface Props extends DIProps {
    renderListingCount: (data: any) => void;
    getListingCount: (data: any) => void;
    viewSku?: string;
    necessaryDetails?: any;
    viewOnAmazon: (data: any) => string;
    fulfillmentType: string;
}
/**
 * This component is responsible for the dashboard structure
 * @param props
 * @returns
 */

function Deleted(props: Props): ReactElement {
    const { t } = useTranslation();
    const myContext: any = useContext(ProductLinkingContext);
    const necessaryDetails = { ...myContext.necessaryDetails };

    const [inputValue, setInputValue] = useState(props.viewSku ?? '');
    const [tableLoading, setTableLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [data, setData] = useState([]);
    const [modalData1, setModalData1] = useState<JSX.Element>(<></>);
    const [deleteModal, setdeleteModal] = useState(false);
    const [modalLoader, setmodalLoader] = useState(true);
    const [popup, setpopup] = useState(false);
    const [sortLabel, setSortLabel] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [count, setCount] = useState(10);
    const [hasPageChanged, setHasPageChanged] = useState(false);
    const [firstRender, setfirstRender] = useState(true);
    const [dataFoundOnAmazon, setDataFoundOnAmazon] = useState<boolean>(false);
    const [deleteData, setDeleteData] = useState<any>({});

    const unlinkedColumns: any = [
        {
            title: '',
            dataIndex: 'image',
            key: 'image',
            width: 50,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">Product</Text>,
            dataIndex: 'product',
            key: 'product',
            width: 150,
        },
        {
            title: '',
            dataIndex: 'amazon',
            key: 'amazon',
            align: 'center',
            width: 150,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Amazon SKU and Barcode")}</Text>,
            dataIndex: 'sku',
            key: 'sku',
            width: 150,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Action")}</Text>,
            key: 'action',
            dataIndex: 'action',
            width: 100,
            align: 'center',
        },
    ];

    const handleTotalpage = (totalProducts: number) => {
        let pages = 0;
        if (totalProducts % count === 0) {
            pages = totalProducts / count;
        } else {
            pages = Math.trunc(totalProducts / count) + 1;
        }
        setTotalPage(pages);
    };

    const getDeletedListing = () => {
        let data: any = {};
        let filters: any = {};
        data = {
            ...necessaryDetails,
            data: {
                matched: 'deleted',
                activePage: currentPage,
                count: count,
            },
            'fulfillment-channel':
                myContext.fulfillmentType == 'FBM' ? 'DEFAULT' : 'FBA',
        };
        if (firstRender && props.location.state?.sku) {
            data = {
                ...data,
                filter: { 'seller-sku': { '1': props.location.state.sku } },
            };
        } else if (inputValue != '') {
            filters = {
                or_filter: {
                    'item-name': { '3': inputValue },
                    'seller-sku': { '3': inputValue },
                    'product-id': { '3': inputValue },
                },
            };
            data = Object.assign({ ...data }, filters);
        }
        firstRender && setfirstRender(false);

        if (sortLabel !== '') {
            data = Object.assign({ ...data }, { sortBy: sortLabel });
        }

        if (!tableLoading) setTableLoading(true);
        props.di.POST(`amazon/product/getAmazonListing`, data).then((val) => {
            if (val.success) {
                myContext.getListingCount('deleted');
                myContext.renderListingCount({ deleted: val?.total_products });
                handleTotalpage(val?.total_products);
                setProducts(val.response);
                setTableLoading(false);
            } else {
                setTableLoading(false);
                props.error(t(val.error) ?? t('Request unsuccessful'));
            }
        });
    };

    useEffect(() => {
        if (props?.location?.state?.from == 'transferOrder') {
            setInputValue(props?.location?.state?.sku);
        }
    }, []);

    var debounceListing = debounce(() => getDeletedListing(), 1000);

    useEffect(() => {
        getDeletedListing();
        // }, [hasPageChanged, sortLabel, props.fulfillmentType]);
    }, [hasPageChanged, sortLabel]);

    useEffect(() => {
        setCurrentPage(1);
        setHasPageChanged(!hasPageChanged);
    }, [myContext.fulfillmentType])

    useEffect(() => {
        debounceListing();
    }, [inputValue]);

    useEffect(() => {
        return () => {
            debounceListing.cancel();
        };
    }, [debounceListing]);

    useEffect(() => {
        renderDeletedListing();
    }, [products]);


    const button: any = <InlineStack gap="100" blockAlign='center'>
        <img src={AmazonBtnIcon} height="14px" width="14px" />
        <Icon
            source={ExternalMinor}
            tone="info"
        />
    </InlineStack>;

    const renderDeletedListing = () => {
        let deletedData: any = [];
        if (products.length > 0) {
            products.forEach((val: any, i) => {
                let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
                deletedData.push({
                    key: i,
                    // image: (
                    //     <img
                    //         height={'60px'}
                    //         width={'60px'}
                    //         src={
                    //             val?.['image-url'] && val?.['image-url'] != ''
                    //                 ? val?.['image-url']
                    //                 : Noimage
                    //         }
                    //     />
                    // ),
                    image: <LazyThumbnail
                        src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                        alt='productImages'
                        key={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage + 'Thumbnail' + Math.random()}
                        size='medium'
                        className='custom-linking-lazy__thumbnail'
                    />,
                    product: (
                        <BlockStack gap='100'>
                            {val?.['item-name'].length > 100 ? (
                                <Tooltip content={val['item-name']}>
                                    <Text as="h3" variant="headingSm">
                                        {val['item-name'].substring(0, 100)}...
                                    </Text>
                                </Tooltip>
                            ) : (
                                <Text as="h3" variant="headingSm">
                                    {val['item-name'].substring(0, 25)}...
                                </Text>
                            )}
                            {/* <Link
                                url={myContext.viewOnAmazon(val?.['asin1'])}
                                target='_blank'
                                removeUnderline>
                                View on Amazon
                            </Link> */}
                            <ViewMoreInfo val={val} renderStatusOfProduct={renderStatusOfProduct} current_shop_currency={current_shop_currency} />
                        </BlockStack>
                    ),
                    amazon: renderStatusOfProduct(val?.['status']),
                    sku: <BlockStack gap="100">
                        <InlineStack gap="100">
                            <Text as="p" fontWeight="regular">SKU:</Text>
                            <Text as="p" tone="subdued">
                                {val?.['seller-sku']}
                            </Text>
                        </InlineStack>
                        <InlineStack gap="100">
                            <Text as="p" fontWeight="regular">Barcode:</Text>
                            <Text as="p" tone="subdued">
                                {val?.['product-id']}
                            </Text>
                        </InlineStack>
                    </BlockStack>,
                    action: (
                        <Button
                            id=""
                            tone='critical'
                            onClick={() => {
                                handledeleteproduct(val);
                            }}>
                            {t("Delete")}
                        </Button>
                    ),
                });
            });
        }
        setData(deletedData);
    };

    const updateText = useCallback((value: any) => {
        setCurrentPage(1);
        setInputValue(value);
    }, []);

    const handleClearButtonClick = useCallback(() => updateText(''), []);

    const handledeleteproduct = (val: any) => {
        renderModal1Data(val);
        setdeleteModal(!deleteModal);
        let obj: any = {
            user_id: val?.user_id,
            sku: val?.['seller-sku'],
        };
        getSingleProductFromAmazon(obj);
    };

    const handledeleteproductApi = () => {
        setdeleteModal(!deleteModal);
        let data: any = {};
        data = {
            ...necessaryDetails,
            deleteData,
            dataFoundOnAmazon,
        };
        props.di.POST(`amazon/request/DeleteProductFromAmazon`, data)
            .then((val) => {
                if (val.success) {
                    props.success(t(val.message));
                    getDeletedListing();
                } else {
                    props.error(t(val.message) ?? t('Request unsuccessful'));
                }
            });
    };

    const getSingleProductFromAmazon = (obj: any) => {
        setdeleteModal(true);
        let data: any = {};
        data = {
            ...necessaryDetails,
            CheckData: { ...obj },
        };
        setDeleteData({ ...obj });
        props.di.POST(`amazon/request/CheckDataOnAmazon`, data).then((val) => {
            if (val.success) {
                setDataFoundOnAmazon(true);
                updateStatusOnApp(obj);
            } else {
                setDataFoundOnAmazon(false);
            }
            setmodalLoader(false);
        });
    };

    const updateStatusOnApp = (obj: any) => {
        let data: any = {};
        data = {
            ...necessaryDetails,
            deleteData: { ...obj },
            dataFoundOnAmazon,
        };
        props.di.POST(`amazon/request/updateStatus`, data).then((val) => {
            if (val.success) {
                getDeletedListing();
                setdeleteModal(!deleteModal);
            } else {
                props.error(t(val.message) ?? t('Request unsuccessful'));
            }
        });
    };

    const renderStatusOfProduct = (status: string) => {
        if (status === 'Active') {
            return <Badge tone="success">{t(status)}</Badge>;
        } else if (status === 'Incomplete') {
            return <Badge tone="warning">{t(status)}</Badge>;
        }
        return <Badge tone="critical">{t(status)}</Badge>;
    };

    const renderModal1Data = (val: any) => {
        let modaldata: JSX.Element = <></>;
        modaldata = (
            <div className="custom-productlinking">
                <BlockStack gap='800'>
                    <Text as="h3" variant="headingSm"> {t("AMAZON PRODUCT")} </Text>
                    <InlineStack gap='400'>
                        <InlineStack wrap={false} gap='400'>
                            {/* <img src={val?.['image-url'] ?? Noimage} height="60px" width='60px' /> */}
                            <LazyThumbnail
                                src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                                alt='productImages'
                                key={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage + 'Thumbnail' + Math.random()}
                                size='medium'
                                className='custom-linking-lazy__thumbnail'
                            />,
                            <BlockStack gap='100'>
                                <div style={{ maxWidth: '200px' }}>
                                    {val?.['item-name'].length > 25 ?
                                        <Tooltip content={val['item-name']}>
                                            <Text as="p" tone="subdued">{val['item-name'].substring(0, 25)}...</Text>
                                        </Tooltip>
                                        : <Text as="p" tone="subdued">{val['item-name']}</Text>
                                    }
                                </div>
                                <div> {renderStatusOfProduct(val?.['status'])} </div>
                            </BlockStack>
                        </InlineStack>
                        <div>
                            <InlineStack gap='200'>
                                <Text as="p">{t("Seller SKU:")}</Text>
                                <Text as="p" tone="subdued">{val?.['seller-sku']}</Text>
                            </InlineStack>
                            <InlineStack gap='200'>
                                <Text as="p">{t("Barcode:")}</Text>
                                <Text as="p" tone="subdued">{val?.['product-id']}</Text>
                            </InlineStack>
                            {/* <Link
                                url={myContext.viewOnAmazon(val?.['asin1'])}
                                target='_blank'
                                removeUnderline>
                                View On Amazon
                            </Link> */}
                        </div>
                    </InlineStack>
                </BlockStack>
            </div>
        );
        setModalData1(modaldata);
    };

    const toggleActive = useCallback(() => setpopup((popup) => !popup), []);

    const popoveractivator = (
        <Button onClick={toggleActive} disclosure>
            {t("Sort By:")} {sortLabel}
        </Button>
    );

    const handleActionList = (sort: string) => {
        setCurrentPage(1);
        setSortLabel(sort);
    };

    const handlePreviousPagination = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
        setHasPageChanged(!hasPageChanged);
    };

    const handleNextPagination = () => {
        if (currentPage !== totalPage) setCurrentPage(currentPage + 1);
        setHasPageChanged(!hasPageChanged);
    };

    return (
        <div>
            <BlockStack gap='200'>
                <InlineStack gap='100' wrap={false}>
                    <div style={{ flex: '1 1 auto' }}>
                        <TextField
                            onChange={updateText}
                            value={inputValue}
                            prefix={<Icon source={SearchMinor} tone="base" />}
                            placeholder={t("Search by Amazon Title, Barcode, or SKU")}
                            onClearButtonClick={handleClearButtonClick}
                            clearButton={true}
                            label=""
                            autoComplete=""
                        />
                    </div>
                    <div className="custom-sort" style={{ flex: '0 0 auto' }}>
                        <Popover
                            active={popup}
                            activator={popoveractivator}
                            autofocusTarget="first-node"
                            onClose={toggleActive}>
                            <ActionList
                                actionRole="menuitem"
                                sections={[
                                    {
                                        title: t('Title'),
                                        items: [
                                            { content: t('Alphabetically (A-Z)'), onAction: () => handleActionList('A-Z') },
                                            { content: t('Alphabetically (Z-A)'), onAction: () => handleActionList('Z-A') },
                                        ],
                                    }
                                ]}
                            />
                        </Popover>
                    </div>
                </InlineStack>
                <div className="custom-productlinking">
                    <Card padding="0">
                        {!tableLoading ? (
                            <Table
                                id="failedOrder_tour_6"
                                sticky
                                loading={tableLoading}
                                columns={unlinkedColumns}
                                dataSource={data}
                                scroll={{ x: 800 }}
                                pagination={false}
                                size="middle"
                            />) : (
                            <DeletingSkeleton />
                        )}
                    </Card>
                </div>

                {totalPage > 0 && (
                    <div>
                        <InlineStack align="center" gap='400'>
                            <Pagination
                                label={`${currentPage} / ${totalPage}`}
                                hasPrevious={currentPage > 1}
                                onPrevious={() => {
                                    handlePreviousPagination();
                                }}
                                hasNext={currentPage != totalPage}
                                onNext={() => {
                                    handleNextPagination();
                                }}
                            />
                        </InlineStack>
                    </div>
                )}
            </BlockStack>
            <Modal
                size='large'
                open={deleteModal}
                onClose={() => {
                    setdeleteModal(false);
                    setmodalLoader(true);
                }}
                title={t("Delete Product")}
                loading={modalLoader}
                primaryAction={
                    !dataFoundOnAmazon
                        ? {
                            content: t('Confirm'),
                            onAction: handledeleteproductApi,
                            disabled: modalLoader,
                        }
                        : undefined
                }
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: () => {
                            setdeleteModal(false);
                            setmodalLoader(true);
                        },
                    },
                ]}>
                <Modal.Section>
                    <BlockStack gap='500'>
                        {modalData1}
                        {dataFoundOnAmazon ? (
                            <BlockStack gap='200'>
                                <Text as="p" fontWeight="semibold">
                                    {t("Product found on Amazon!")}
                                </Text>
                                <Text as="p">
                                    {t("Product's status  has been synced from Amazon to the app.")}
                                </Text>
                            </BlockStack>
                        ) : (
                            <BlockStack gap='200'>
                                <Text as="p" fontWeight="semibold">
                                    {t("Product not found on Amazon!")}
                                </Text>
                                <Text as="p">
                                    {t("Are you sure you want to Delete this Product from App?")}
                                </Text>
                            </BlockStack>
                        )}
                    </BlockStack>
                </Modal.Section>
            </Modal>
        </div>
    );
}
export default DI(Deleted);